import { render, staticRenderFns } from "./MenuRefund.vue?vue&type=template&id=54231ee0&scoped=true&"
import script from "./MenuRefund.vue?vue&type=script&lang=js&"
export * from "./MenuRefund.vue?vue&type=script&lang=js&"
import style0 from "./MenuRefund.vue?vue&type=style&index=0&id=54231ee0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54231ee0",
  null
  
)

export default component.exports